// extracted by mini-css-extract-plugin
module.exports = {"component":"onboarding-flow-finish-step-form-module_component__hPGh_","container":"onboarding-flow-finish-step-form-module_container__xLw00"};